import {memo, useMemo} from 'react';
import styled from 'styled-components';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import {
    useMenuColor,
    useLogoColorVariable,
    useIsDesktop
} from '@repo/ui';
import DesktopContent from '@/components/Menu/desktop/DesktopContent';
import TopRow from '@/components/Menu/shared/TopRow';
import MobileContent from '@/components/Menu/mobile/MobileContent';
import VerticalCarousel from '@/components/Menu/desktop/VerticalCarousel';
import { THEME_MODES } from "@repo/ui/themeSettings";

const StyledWrapper = styled.div`
    .underline-animation {
        &:before {
            background: ${({ theme, $underlineColor }) => $underlineColor ? $underlineColor : theme.colors.white};
        }
    }

    .underline-animation-lowercase {
        &:before {
            background: ${({ theme }) => theme.mode === THEME_MODES.LIGHT ? theme.colors.white : theme.colors.twilightBlue};
        }
    }
`

const StyledContentWrapper = styled.div`
    position: fixed; 
    background: transparent;
    z-index: 50;
    top: 0;
    left: 0;
    transform: translateY(-100%);
    width: 100%;
    height: 100dvh;
`;

const StyledMenuContent = styled.ul`
	width: 100%;
	height: 100dvh;
`;

const Menu = ({ menu: menuData, globals }) =>  {
    const menu = menuData?.length > 0 ? menuData[0] : null
    const menuItems = menu?.menuItems || [];
    const firstMenuItem = (menuItems[0] || '');
    const contactButtonText = menu?.contactButtonText || ''
    const contactButtonLink = menu?.contactButtonLink || []
    const finalUnderlineColor = useFinalUnderlineColor()
    const isDesktop = useIsDesktop(false)
    const wrapperRef = useRef(null);

    return (
        <StyledWrapper $underlineColor={finalUnderlineColor}>
            <TopRow firstMenuItem={firstMenuItem} contactButtonText={contactButtonText} contactButtonLink={contactButtonLink} />
            <VerticalCarousel data={menu} />
            <StyledContentWrapper ref={wrapperRef} className='menu-content-wrapper'>
                <StyledMenuContent className="menu-content">
                    {isDesktop ? (
                        <DesktopContent globals={globals} data={menu} />
                    ) : (
                        <MobileContent globals={globals} data={menu} />
                    )}
                </StyledMenuContent>
            </StyledContentWrapper>
        </StyledWrapper>
    );
}

function useFinalUnderlineColor() {
    const isMenuOpen = useSelector((state) => state.menu.open);
    const iconMenuOpenColor = useMenuColor()
    const iconMenuNotOpenColor = useLogoColorVariable()

    return useMemo(() => {
        return isMenuOpen ? iconMenuOpenColor : iconMenuNotOpenColor
    }, [iconMenuOpenColor, iconMenuNotOpenColor, isMenuOpen])
}

export default memo(Menu)
